import { HttpClient } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { appConfigService } from '@app/config';
import { ParentItemProviderService } from '@app/shared';
import { JedinicaGradiva } from '@app/shared/models/jedinica-gradiva';
import { DynamicFormService } from '@ntap/common';
import {
  AuthRequestOptions,
  ItemInfo,
  ListViewProviderDirective
} from '@ntap/core';
import { PrimeNGButtonNewItemViewActionComponent } from '@ntap/primeng';
import { first, switchMap } from 'rxjs';

@Component({
  selector: `app-generiraj-jedinica-gradiva-izlucivanje-rel-action`,
  templateUrl:
    '../../shared/components/odabir-jedinica-gradiva/odabir-jedinica.component.html',
  providers: [DynamicFormService, ParentItemProviderService]
})
export class GenerirajJedinicaGradivaIzlucivanjeRelActionComponent extends PrimeNGButtonNewItemViewActionComponent {
  public showDialog = false;

  private listviewProvider = inject(ListViewProviderDirective);
  private parentItemViewProvider = inject(ParentItemProviderService);

  private httpClient = inject(HttpClient);
  private config = inject(appConfigService);

  public refresh() {
    this.listviewProvider.refresh();
  }

  public onSelectedItem(jedinice: JedinicaGradiva[]) {
    return this.parentItemViewProvider.parentItem$
      .pipe(
        first(),
        switchMap((parent: any) => {
          const formData = {
            jediniceIds: jedinice.map((j) => j['en~jedinica_gradiva~id']),
            izlucivanjeId: new ItemInfo(parent).id
          };

          return this.httpClient.post(
            `${this.config.apiHost}jedinica-gradiva-izlucivanje-rel`,
            formData,
            new AuthRequestOptions()
          );
        })
      )
      .subscribe({
        next: () => {
          const message =
            jedinice.length > 1
              ? 'Jedinice gradiva uspješno dodane u izlučivanje'
              : 'Jedinica gradiva uspješno dodana u izlučivanje';
          this.notificationService.success(message);
          this.listviewProvider.refresh();
        },
        error: () => {
          const errorMessage =
            jedinice.length > 1
              ? 'Greška pri dodavanju jedinica gradiva'
              : 'Greška pri dodavanju jedinice gradiva';
          this.notificationService.error(errorMessage);
        },
        complete: () => {
          this.showDialog = false;
        }
      });
  }
}
